<template><div><h1>VUX V2.7.3 发布日志</h1>
<h2><a href="/zh-CN/components/confirm.html">Confirm</a></h2>
<ul><li>[fix] 修复输入框难以获取 focus 的问题（感谢 @Sapphire2k）</li>
</ul>
<h2><a href="/zh-CN/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[fix] 修复 disable-date-function 取值与禁用周末逻辑冲突 #2189</li>
</ul>
<h2><a href="/zh-CN/components/picker.html">Picker</a></h2>
<ul><li>[enhance] 渲染出错时提示是否联动数据忘了指定列数</li>
</ul>
<h2><a href="/zh-CN/components/rater.html">Rater</a></h2>
<ul><li>[feature] prop:star 支持 html #2182</li>
</ul>
<h2><a href="/zh-CN/components/search.html">Search</a></h2>
<ul><li>[fix] 修复输入法导致 on-change 事件提前触发</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.7.3 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.7.3-266.vue?27e64019